export default __webpack_public_path__ + "static/media/h5-home-banner2.f149be1f.png";